type TDate = {
    year: 'numeric';
    month: 'numeric';
    day: 'numeric';
};

const dateFormat = (dateString: string): string => {
    if (dateString === '0001-01-01T00:00:00Z') return '';
    let options: TDate = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    };
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', options);
};

export default dateFormat;
